import axios from 'axios';

const API_URL = process.env.VUE_APP_API_BASE_URL + 'wallet/';

class WalletService {
  getGoogleGuestPassJwt(user_id) {
    var full_api_url = API_URL+ "googleguest?id=" + user_id;

    return axios
      .get(full_api_url, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        console.log(response.data)
        return response.data;
      });
  }

  emailAppleGuestPass(user_id, email) {
    var full_api_url = API_URL;

    var params = { "id": user_id, "email": email }

    return axios
      .post(full_api_url, params, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });

  }

}



export default new WalletService();
